{
  "common.close": "Lukk",
  "common.athleteFallback": "utøver {id}",
  "splash.title": "{app} — animert visualisering av aktiviteter",
  "splash.tagline": "Strava-dataene dine i&nbsp;bevegelse",
  "splash.demo": "Demo",
  "tab.query.title": "Kartet til {name}",
  "tab.query.heading": "Hent aktiviteter:",
  "tab.query.optDays": "siste dager",
  "tab.query.optActivities": "siste aktiviteter",
  "tab.query.optIds": "Aktivitets-ID-er",
  "tab.query.optDates": "Datoområde",
  "tab.query.idsPlaceholder": "skriv inn aktivitets-ID-er her",
  "tab.query.after": "Etter:",
  "tab.query.before": "Før:",
  "tab.query.autozoom": "Zoom automatisk <i class=\"hf hf-bullseye\"></i> til utvalget etter import",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Hent",
  "tab.query.createAccount": "Opprett en konto og/eller logg inn.",
  "tab.query.sports": "Idretter:",
  "tab.query.allSports": "Alle idretter",
  "tab.query.sportsExcept": "Alle unntatt",
  "tab.query.sportsNone": "Ingen",
  "tab.query.loadingSports": "Laster idretter…",
  "tab.query.sportsFailed": "Kunne ikke laste idrettene på dette kartet",
  "tab.query.noSports": "Ingen aktiviteter ennå",
  "tab.activities.title": "Viste aktiviteter",
  "tab.activities.clearSelection": "Fjern utvalg",
  "tab.activities.renderSelected": "Vis valgte",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Zoom til utvalget",
  "tab.controls.title": "Laginnstillinger",
  "tab.controls.timescale": "Tidsskala <i>&tau;</i>",
  "tab.controls.timescaleHint": "avspillingshastighet",
  "tab.controls.period": "Periode <i>T</i>",
  "tab.controls.periodHint": "aktivitet ~ modell",
  "tab.controls.dotSize": "Punktstørrelse",
  "tab.controls.pathWidth": "Linjebredde",
  "tab.controls.pathWidthHint": "null skjuler linjene",
  "tab.controls.colors": "Farger",
  "tab.controls.colorsHint": "roter fargepaletten",
  "tab.controls.shadows": "Skygger",
  "tab.profile.loginTitle": "Logg inn",
  "tab.profile.anonNote": "Logg inn med Strava for å se dine egne aktiviteter og administrere Heatflask-kontoen din.",
  "tab.profile.loginLink": "Logg inn med Strava",
  "tab.profile.editOnStrava": "Rediger profilen din på Strava",
  "tab.profile.indexNote": "Vi indekserer sammendragene av aktivitetene dine for rask tilgang.",
  "tab.profile.viewIndex": "Vis indeks",
  "tab.profile.sharedMaps": "Delte kart",
  "tab.profile.sharedMapsNote": "Av: bare du kan se aktivitetene dine i Heatflask. På: alle med en lenke til kartet ditt kan se aktivitetene du har gjort offentlige på Strava. De private forblir dine uansett. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Slik fungerer personvernet</a>",
  "tab.profile.logout": "Logg ut",
  "tab.profile.deleteAccount": "Slett konto",
  "tab.profile.deleteConfirm": "Vil du slette Heatflask-kontoen din?\n\nDette fjerner de indekserte aktivitetene dine og trekker tilbake Heatflasks tilgang til Strava-dataene dine. Det kan ikke angres.",
  "tab.profile.languageHeading": "Språk",
  "tab.profile.languageAuto": "Automatisk",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Hjelp oss med å rette eller legge til oversettelser!</a>",
  "tab.profile.unitsHeading": "Enheter",
  "tab.profile.unitsAuto": "Automatisk",
  "tab.profile.unitsMetric": "Metrisk (km, m)",
  "tab.profile.unitsImperial": "Imperisk (mi, ft)",
  "tab.profile.textSizeHeading": "Tekststørrelse",
  "tab.profile.textSmaller": "Mindre",
  "tab.profile.textReset": "Normal",
  "tab.profile.textLarger": "Større",
  "tab.profile.mapDefaultsHeading": "Kartstandarder",
  "tab.profile.mapDefaultsNote": "Start med dette bakgrunnskartet, terrenget og laginnstillingene når du åpner et kart der lenken ikke angir sine egne. Lenker du deler viser fortsatt nøyaktig det du ser.",
  "tab.profile.mapDefaultsSave": "Lagre som mine standarder",
  "tab.profile.mapDefaultsForget": "Glem",
  "tab.info.title": "Info",
  "tab.info.controlsHeading": "Styring",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + dra",
  "tab.info.shiftDragDesc": "Velg aktiviteter innenfor en boks. På berøringsskjerm trykker du først på <i class=\"hf-object-group\"></i> og drar deretter med én finger. Den sist valgte aktiviteten viser detaljene sine, og aktivitetslisten ruller til den.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + dra",
  "tab.info.ctrlDragDesc": "Roter og vipp kartet i 3D, eller bruk to fingre",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Åpne eller lukk sidepanelet",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Forrige eller neste fane",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Lukk sidepanelet",
  "tab.info.liveUrlHeading": "Levende URL",
  "tab.info.liveUrlDesc": "Kartutsnittet og animasjonsinnstillingene lagres i sidens URL, så alle du deler den med, ser det samme.",
  "tab.info.videoHeading": "Videoeksport",
  "tab.info.videoDesc": "Knappen <i class=\"hf-video-camera\"></i> tar opp animasjonen som MP4: trykk på den, juster boksen over den delen av kartet du vil ha med, og trykk igjen for å ta opp. Én hel runde av animasjonen tas opp, slik at videoen går sømløst i loop; en runde som varer lenger enn {max} sekunder (den lengste videoen Strava godtar), kuttes ved {max}.",
  "tab.info.contributeHeading": "Bidra",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Støtt på GitHub",
  "tab.info.contactsHeading": "Kontakt",
  "map.basemapAndTerrain": "Bakgrunnskart og terreng",
  "map.pauseAnimation": "Sett animasjonen på pause",
  "map.resumeAnimation": "Fortsett animasjonen",
  "capture.record": "Ta opp video ({period} s per runde)",
  "capture.recordTruncated": "Ta opp video (én runde varer {period} s; bare de første {max} s tas opp)",
  "capture.recordArea": "Ta opp området inni boksen",
  "capture.stop": "Stopp opptaket",
  "capture.selectionTooSmall": "utvalget er for lite",
  "capture.saved": "lagret {name} ({size})",
  "capture.cancelled": "opptaket ble avbrutt",
  "capture.failed": "opptaket mislyktes: {error}",
  "capture.loadingEncoder": "laster inn koder…",
  "capture.waitingForMap": "venter på at kartet skal lastes…",
  "capture.encoding": "koder… {percent} %",
  "capture.finalizing": "fullfører…",
  "share.title": "Del en lenke til dette kartet",
  "share.copied": "lenken er kopiert",
  "share.copiedUnshared": "lenken er kopiert – men kartet ditt er ikke delt, så ingen andre kan åpne det. Slå på «Delte kart» for å endre det.",
  "share.unshared": "Kartet ditt er ikke delt, så ingen andre kan åpne denne lenken. Slå på «Delte kart» for å endre det.",
  "share.copyThis": "Kopier denne lenken:",
  "update.available": "En ny versjon av Heatflask er tilgjengelig.",
  "update.reload": "Last inn på nytt",
  "import.title": "Importerer",
  "import.stop": "Stopp",
  "import.stopping": "stopper…",
  "import.contacting": "kobler til Strava…",
  "import.countOf": "Aktiviteter: {received} av {total}",
  "import.count": "Aktiviteter: {received}",
  "import.waitStrava": "Satt på pause til {time} av Stravas nedlastingsgrense. La siden være åpen; å laste inn på nytt gjør det ikke raskere.",
  "import.waitRationed": "Dagens raske nedlastinger er brukt opp. Resten fortsetter kl. {time}, saktere. La siden være åpen.",
  "import.dailyLimit": "Stravas daglige nedlastingsgrense er nådd. Prøv igjen etter {time}.",
  "import.dailyRationed": "Du har brukt din andel av Strava-nedlastinger for i dag. Prøv igjen etter {time}.",
  "import.noActivitiesYet": "Strava-kontoen din har ingen aktiviteter ennå. Registrer eller last opp en på Strava, så dukker den opp her.",
  "table.noActivities": "ingen aktiviteter",
  "table.untitled": "(uten tittel)",
  "activities.pageTitle": "{app} — Aktivitetsindeks",
  "activities.heading": "Aktivitetsindeks",
  "activities.fetching": "Henter aktiviteter...",
  "activities.rateLimit": "Stravas forespørselsgrense er nådd; fortsetter kl. {time}",
  "activities.noData": "Beklager, ingen data &#128577;",
  "activities.colServerCache": "Sporet er mellomlagret på serveren (Mongo)",
  "activities.colBrowserCache": "Sporet er mellomlagret i denne nettleseren",
  "activities.cachedServer": "Sporet for {id} er mellomlagret på serveren",
  "activities.notCachedServer": "Sporet for {id} er ikke mellomlagret på serveren",
  "activities.cachedBrowser": "Sporet for {id} er mellomlagret i denne nettleseren",
  "activities.notCachedBrowser": "Sporet for {id} er ikke mellomlagret i denne nettleseren",
  "sport.AlpineSki": "Alpint",
  "sport.BackcountrySki": "Randonee",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Basketball",
  "sport.Canoeing": "Kano",
  "sport.Cricket": "Cricket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Dans",
  "sport.EBikeRide": "El-sykkeltur",
  "sport.Elliptical": "Ellipsemaskin",
  "sport.EMountainBikeRide": "Tur på el-terrengsykkel",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Grustur",
  "sport.Handcycle": "Håndsykkel",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Fottur",
  "sport.IceSkate": "Skøyter",
  "sport.InlineSkate": "Rulleskøyter",
  "sport.Kayaking": "Kajakk",
  "sport.Kitesurf": "Kitesurfing",
  "sport.MountainBikeRide": "Terrengsykkeltur",
  "sport.NordicSki": "Langrenn",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Fysioterapi",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Sykkeltur",
  "sport.RockClimbing": "Klatring",
  "sport.RollerSki": "Rulleski",
  "sport.Rowing": "Roing",
  "sport.Run": "Løp",
  "sport.Sail": "Seiling",
  "sport.Skateboard": "Skateboard",
  "sport.Snowboard": "Snøbrett",
  "sport.Snowshoe": "Truger",
  "sport.Soccer": "Fotball",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Trappemaskin",
  "sport.StandUpPaddling": "Padlebrett",
  "sport.Surfing": "Surfing",
  "sport.Swim": "Svømming",
  "sport.TableTennis": "Bordtennis",
  "sport.Tennis": "Tennis",
  "sport.TrailRun": "Terrengløp",
  "sport.Velomobile": "Velomobil",
  "sport.VirtualRide": "Virtuell sykkeltur",
  "sport.VirtualRow": "Virtuell roing",
  "sport.VirtualRun": "Virtuelt løp",
  "sport.Volleyball": "Volleyball",
  "sport.Walk": "Gåtur",
  "sport.WeightTraining": "Styrketrening",
  "sport.Wheelchair": "Rullestol",
  "sport.Windsurf": "Brettseiling",
  "sport.Workout": "Trening",
  "sport.Yoga": "Yoga"
}
